import {DataModificationsHeader} from 'audit/DataModifications';
import {ACTION_CREATE_ROW_BOXES} from 'notebook/store/VersioningConstants';
import {doPerformCreateBoxes} from 'notebook/structured-tables/action-functions/createBoxesActionFunction';
import makeSubmitRowActionFunction, {
  getRowAwareLoadingMessage,
} from 'notebook/structured-tables/action-functions/makeSubmitRowActionFunction';
import {
  ActionResultType,
  performServerSideTableWriteActionWithAudits,
} from 'notebook/structured-tables/action-functions/PerformActionFunctions';
import invokeStructuredTableMappings from 'notebook/structured-tables/structured-table-mappings/invokeStructuredTableMappings';
import {AxisContextMenuActionFunctionParameters} from 'notebook/structured-tables/StructuredTableConstants';
import {TableSubmissionDiffs} from 'notebook/structured-tables/util/datamods/getStructuredTableCellDiffOnSubmission';

import {
  BoxCreationStructuredTable,
  BoxCreationTableMetadata,
  BoxCreationTableRowMetadata,
} from '../../integrations/samples/BoxCreationStructuredTableAdapter';

export const SUBMIT_BOX_CREATION_ROW_ACTION_FUNCTION_CONFIG = {
  allowOutsideOfEntry: false,
  onSelectForSubmit: async (
    actionFunctionParams: AxisContextMenuActionFunctionParameters<
      BoxCreationTableMetadata,
      BoxCreationTableRowMetadata
    >
  ): Promise<void> => {
    const entryId = actionFunctionParams.entryOrTemplateId!;
    const boxCreationStructuredTable: BoxCreationStructuredTable = actionFunctionParams.structuredTable;
    const selection = {
      start: actionFunctionParams.selectionRange!.minIndex,
      end: actionFunctionParams.selectionRange!.maxIndex + 1,
    };

    await performServerSideTableWriteActionWithAudits({
      entryId,
      loadingScreenMessage: getRowAwareLoadingMessage(
        selection,
        'Updating Boxes For Rows',
        'Updating Box For Row'
      ),
      autoSaverAction: ACTION_CREATE_ROW_BOXES,
      doPerformAction: (
        tableSubmissionDiffs?: TableSubmissionDiffs,
        updateStatus?: (msg: string) => void,
        dataModsHeader?: DataModificationsHeader
      ) =>
        doPerformCreateBoxes(
          entryId,
          boxCreationStructuredTable,
          actionFunctionParams.computedTable,
          actionFunctionParams.actionFunctionContext,
          tableSubmissionDiffs,
          selection,
          updateStatus,
          dataModsHeader
        ),
      doPostRefresh: (actionResult) => {
        invokeStructuredTableMappings(
          entryId,
          boxCreationStructuredTable,
          actionResult.resultType === ActionResultType.PARTIAL_SUCCESS
            ? actionResult.submittedRange
            : selection
        );
        return Promise.resolve();
      },
      analyticsActionForPerfTracking: 'submit_box_creation_structured_table_rows',
      structuredTables: [boxCreationStructuredTable],
      structuredTableAdapters: [actionFunctionParams.structuredTableAdapter],
      computedTables: [actionFunctionParams.computedTable],
      tables: actionFunctionParams.table ? [actionFunctionParams.table] : [],
      selection,
    });
  },
};

export default makeSubmitRowActionFunction<BoxCreationTableMetadata, BoxCreationTableRowMetadata>(
  SUBMIT_BOX_CREATION_ROW_ACTION_FUNCTION_CONFIG
);
